import { Badge, HStack } from '@chakra-ui/react'
import { CheckSquare, FileText, MapPin, Package } from 'lucide-react'
import type { ChildTicketTask } from '@/lib/services/childTicketService'
import { matchesTaskSourceField } from './taskSourceFieldUtils'

export type TaskUiType = 'fe_visit' | 'parts_procurement' | 'document_collection' | 'generic'

const FE_VISIT_ACTION_TYPES = new Set(['fe_visit', 'field_visit', 'fe_schedule'])

export function resolveTaskUiType(task: ChildTicketTask): TaskUiType {
  const actionType = (task.action_type ?? '').trim()

  if (matchesTaskSourceField(task, 'fe_visit') || FE_VISIT_ACTION_TYPES.has(actionType)) {
    return 'fe_visit'
  }
  if (actionType === 'parts_procurement') {
    return 'parts_procurement'
  }
  if (actionType === 'document_collection' || actionType === 'work_permit') {
    return 'document_collection'
  }
  return 'generic'
}

const UI_TYPE_CONFIG: Record<
  TaskUiType,
  { label: string; colorScheme: string; Icon: typeof MapPin }
> = {
  fe_visit: { label: 'Field Visit', colorScheme: 'cyan', Icon: MapPin },
  parts_procurement: { label: 'Parts Procurement', colorScheme: 'orange', Icon: Package },
  document_collection: { label: 'Document', colorScheme: 'purple', Icon: FileText },
  generic: { label: 'Task', colorScheme: 'gray', Icon: CheckSquare },
}

export function TaskTypeBadge({ type }: { type: TaskUiType }): JSX.Element {
  const { label, colorScheme, Icon } = UI_TYPE_CONFIG[type]

  return (
    <Badge
      colorScheme={colorScheme}
      borderRadius="full"
      px={2.5}
      py={0.5}
      fontWeight="600"
      fontSize="xs"
      textTransform="none"
    >
      <HStack spacing={1} align="center">
        <Icon size={14} />
        <span>{label}</span>
      </HStack>
    </Badge>
  )
}
